import { FETCH_EARLY_COD_CHARGES_SUCCESS, FETCH_EARLY_COD_CHARGES_REQUEST, FETCH_EARLY_COD_CHARGES_FAILURE, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getEarlyCODChargesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EARLY_COD_CHARGES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_EARLY_COD_CHARGES_REQUEST:
            return Object.assign({}, state);
        case FETCH_EARLY_COD_CHARGES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getEarlyCODChargesReducer;
